import React from "react";
import { ReferenceInput, required, SelectInput } from "react-admin";
import { useField } from "react-final-form";
import { SchoolIdSelected } from "utils/tools";

const AcademicYearInput = ({ parentCallback }: any) => {
  const schoolId = Number(SchoolIdSelected());
  const date = useField("date");

  return (
    <ReferenceInput
      label="Academic Year"
      source="academicYearId"
      reference="academicYears"
      filter={{ SchoolId: schoolId }}
      onChange={({ target }) => {
        parentCallback && parentCallback(target.value);
        date.input.onChange("");
      }}
      validate={required()}
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
  );
};

export default AcademicYearInput;
